import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import * as R from 'ramda'

const useStyle = makeStyles((theme) => ({
  formInput: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.primary.main,
    },
    '& .MuiIcon-root': {
      color: theme.palette.darkGrey.main,
    },
  },
}))
export const ItemType = {
  First: 'FirstRow',
  Between: 'Between',
  Last: 'Last',
}
export default (props) => {
  const { IconComponent, Input, itemType = ItemType.Between, className } = props
  const classes = useStyle()
  const spaceBetween = R.cond([
    [R.equals(ItemType.First), R.always('my-24')],
    [R.equals(ItemType.Between), R.always('mb-24')],
    [R.equals(ItemType.Last), R.always('')],
    [R.T, R.always('')],
  ])(itemType)
  return (
    <div className={clsx(classes.formInput, 'flex', className, spaceBetween)}>
      <div className="min-w-36 sm:min-w-48 pt-20">{IconComponent}</div>
      <div className="flex-1 min-w-0">{Input}</div>
    </div>
  )
}
